// Adapted from davinci-elections apps/web/src/theme/recipes/list.ts @ 6e23f58
import { defineSlotRecipe } from '@chakra-ui/react'
import { listAnatomy } from '@chakra-ui/react/anatomy'

export const listSlotRecipe = defineSlotRecipe({
  slots: listAnatomy.keys(),
  // No outer margin: every list sits in a Stack whose gap spaces it like the paragraphs around it (a margin added a
  // second, larger gap under each list).
  base: {
    root: {
      marginBottom: 0,
    },
  },
  variants: {
    variant: {
      marker: {
        // Hanging markers: a wrapped line lines up with the text above it, not with the bullet. Every list sets its
        // own start padding (`ps`), which is where the marker sits.
        root: {
          listStylePosition: 'outside',
        },
      },
    },
  },
})
